<template>
  <div class="h-100">
    <b-col class="settings-panel">
      <div class="card">
        <div class="card-header text-center">
          App Settings
        </div>
        <b-col md="12" class="settings-panel-body appsettings" v-if="form">
          <div class="card-block">
            <b-form class="app-settings">
              <b-form-group id="exampleInputGroup1" label="Max simultaneous read / write requests per IP" label-for="max_simultaneous_read">
                <vue-slider class="py-4" id="max_simultaneous_read" ref="maxSimul" :show="showSlider" v-model="form.MAX_SIMULTANEOUS_REQUEST_PER_IP" v-bind="maxSimulProps">
                  <template slot="label" slot-scope="{ label, active }">
                    <span :class="['custom-label', { active }]" v-if="label==1">
                      {{ label }}
                    </span>
                    <span :class="['custom-label', { active }]" v-if="label % 10 === 0">
                      {{ label }}
                    </span>
                  </template>
                </vue-slider>
              </b-form-group>
            </b-form>
              <hr/>
            <b-form>
              <b-form-group id="exampleInputGroup1" label="Max simultaneous requests from this server (in which IWP is installed)" label-for="max_simultaneous_iwp">
                <vue-slider class="py-4" id="max_simultaneous_iwp" ref="slider" :show="showSlider" v-model="form.MAX_SIMULTANEOUS_REQUEST" v-bind="maxSimulIWPProps">
                  <template slot="label" slot-scope="{ label, active }">
                    <span :class="['custom-label', { active }]" v-if="label==1">
                      {{ label }}
                    </span>
                    <span :class="['custom-label', { active }]" v-if="label % 50 === 0">
                      {{ label }}
                    </span>
                  </template>
                </vue-slider>
              </b-form-group>
            </b-form>
              <hr/>
            <b-form>
              <b-form-group id="exampleInputGroup1" label="Time delay between requests to websites on the same IP (Milli-Seconds)" label-for="time_delay">
                <vue-slider class="py-4" id="time_delay" ref="slider" :show="showSlider" v-model="form.TIME_DELAY_BETWEEN_REQUEST_PER_IP" v-bind="maxTimeDelayProps">
                  <template slot="label" slot-scope="{ label, active }">
                    <span :class="['custom-label', { active }]" v-if="label==1">
                      
                    </span>
                    <span :class="['custom-label', { active }]" v-if="label % 500 === 0">
                      {{ label }}
                    </span>
                  </template>
                </vue-slider>
              </b-form-group>
            </b-form>
              <hr/>
            <b-form class="mt-0 mb-0">
              <b-form-group id="exampleInputGroup1" v-if="form.timeZones" label="Timezone" label-for="time_zone">
                <v-select id="time_zone" :options="form.timeZones" v-model="timezone" :placeholder="'Not set/Unavaliable in the list'">
                </v-select>
                 <div class="label-desc" v-if="!timezone">
                     Default Timezone(null) has been set. We recommend you to set it manually above.
                    </div>
              </b-form-group>
            </b-form>
              <hr/>
            <b-form class="mt--6 mb--6">
              <b-form-checkbox id="reloadData" v-model="form.enableReloadDataPageLoad" value="1" unchecked-value="0" >Reload data on page load.</b-form-checkbox>
            </b-form>
              <hr/>
            <b-form class="mt--6 mb--6">
              <b-form-checkbox id="sendanon" v-model="form.sendAnonymous" value="1" unchecked-value="0">Send anonymous usage information to improve IWP.</b-form-checkbox>
            </b-form>
              <hr/>
            <b-form class="mt--6 mb--6">
              <b-form-checkbox v-model="form.CONSIDER_3PART_IP_ON_SAME_SERVER" value="1" unchecked-value="0" >Consider that the first 3 octets of IP's are from the same server (xxx.xxx.xxx.*)</b-form-checkbox>
            </b-form>
              <hr/>
            <b-form class="mt--6 mb-3">
              <div class="d-flex">
                <b-form-checkbox v-model="autoDeleteLog" value="1" unchecked-value="0"  @change="setDefaultAutoDeleteLog($event)">Auto-delete log data older than</b-form-checkbox>
                <b-form-group class="m-0" v-if="autoDeleteLog=='1'">
                  <b-form-radio-group  id="autoDeleteLogRadio" v-model="autoDeleteLogFreq" :options="autoDeleteLogOptions" name="radioOpenions">
                  </b-form-radio-group>
                </b-form-group>
              </div>
            </b-form>
          </div>
        </b-col>
        <div class="card-footer text-muted text-right">
          <b-btn variant="primary" size="sm" @click="save" :disabled="buttonLoaders.saveChanges">Save Changes
            <spinner size="small" v-if="buttonLoaders.saveChanges"></spinner>
          </b-btn>
        </div>
      </div>
    </b-col>
  </div>
</template>

<script>
import VueSlider from 'vue-slider-component';
import vSelect from 'vue-select';
export default {
  name: 'appsettings',
  props: ['settings'],
  components: { VueSlider,vSelect },
  mounted() {
    this.loadSettings(this.settings);
  },
  data() {
    return {
      form: null,
      buttonLoaders: {
        saveChanges: false
      },
      timezone: {
        label: '',
        value: ''
      },
      value: 1,
      showSlider: false,
      maxSimulProps: {
        piecewiseLabel: true,
        min: 1,
        max: 30
      },
      maxSimulIWPProps: {
        piecewiseLabel: true,
        min: 1,
        max: 100
      },
      maxTimeDelayProps: {
        piecewiseLabel: true,
        min: 0,
        max: 1000
      },
      autoDeleteLogFreq: null,
      autoDeleteLog: 0,
      autoDeleteLogOptions: [
        { text: '90 days', value: '90' },
        { text: '60 days', value: '60' },
        { text: '30 days', value: '30' }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.showSlider = true;
    }, 100);
  },
  methods: {
    loadSettings(settings) {
      let newForm = {};
      if (settings) {
        let settings = _.cloneDeep(this.settings);
        newForm = settings.appSettings;
        if (newForm) {
          let timezones = [];
          _.each(newForm.timeZones, (timezone, key) => {
            timezones.push({ label: timezone, value: key });
          });
          newForm.timeZones = timezones;
          this.timezone = _.find(timezones, { value: newForm.TIMEZONE });
          this.autoDeleteLog = newForm.autoDeleteLog != '0' ? 1 : 0;
          if (this.autoDeleteLog == 1) {
            this.autoDeleteLogFreq = newForm.autoDeleteLog;
          }
        }
      }
      this.form = newForm;
    },
    setDefaultAutoDeleteLog(autoDeleteLog) {
      if (autoDeleteLog === '1' && this.autoDeleteLogFreq == null) {
        this.autoDeleteLogFreq = '90';
      }
    },
    save() {
      this.buttonLoaders.saveChanges = true;
      let payload = {};
      let tempForm = _.cloneDeep(this.form);
      if (this.autoDeleteLog == '1' && this.autoDeleteLogFreq) {
        tempForm.autoDeleteLog = this.autoDeleteLogFreq;
      } else if (this.autoDeleteLog == '0') {
        tempForm.autoDeleteLog = '0';
      }
      delete tempForm.timeZones;
      if(this.timezone){
        tempForm.TIMEZONE = this.timezone.value;
      }

      payload.requiredData = {
        updateSettingsAllV3: {
          appSettings: tempForm
        },
        getSettingsAllV3: 1
      };

      this.$store.dispatch('sendAction', payload).then(response => {
        this.buttonLoaders.saveChanges = false;
        this.$store.commit('SET_SETTINGS', response.data.getSettingsAllV3);
      });
    }
  }
};
</script>

<style scoped>
</style>
